import React, { useState } from "react";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
const TITLE = "حاسبة القاسم المشترك الأكبر";
const DESCRIPTION =
  "احسب القاسم المشترك الأكبر (GCF) لأي مجموعة من الأعداد الصحيحة بسهولة وسرعة. اكتشف العامل المشترك الأكبر بين رقمين أو أكثر في ثوانٍ. استخدم هذه الأداة لحل المسائل الرياضية وتبسيط الكسور. مثالية للطلاب والمعلمين.";
const KEYWORDS =
  "قاسم مشترك أكبر، GCF، آلة حاسبة، أعداد صحيحة، رياضيات، طلاب، معلمين، تبسيط الكسور.";
const OG_URL = "https://do-calculate.com/calculator/ar/gcf-calculator";
const GCFCalculator = () => {
  const [numbers, setNumbers] = useState("");
  const [gcf, setGcf] = useState(null);
  const [steps, setSteps] = useState([]);
  const [error, setError] = useState("");
  const primeFactors = (n) => {
    const factors = [];
    for (let i = 2; i <= n; i++) {
      while (n % i === 0) {
        factors.push(i);
        n = n / i;
      }
    }
    return factors;
  };
  const calculateGCF = (numArray) => {
    const gcd = (a, b) => (!b ? a : gcd(b, a % b));
    return numArray.reduce((acc, num) => gcd(acc, num));
  };
  const handleCalculate = () => {
    try {
      if (!numbers) {
        throw new Error("الرجاء إدخال أرقام مفصولة بفواصل.");
      }
      const numArray = numbers.split(",").map(Number);
      if (numArray.some(isNaN)) {
        throw new Error("الرجاء إدخال أرقام صحيحة مفصولة بفواصل.");
      }
      const gcfValue = calculateGCF(numArray);
      const stepsArray = numArray.map((num) => {
        const factors = primeFactors(num);
        return `${num} = ${factors.join(" × ")}`;
      });
      const commonFactors = stepsArray.reduce((acc, step) => {
        const factors = step.split(" = ")[1].split(" × ").map(Number);
        return acc.filter((factor) => factors.includes(factor));
      }, primeFactors(numArray[0]));
      const gcfSteps = `GCF(${numArray.join(", ")}) = ${commonFactors.join(
        " × "
      )} = ${gcfValue}`;
      setGcf(gcfValue);
      setSteps([...stepsArray, gcfSteps]);
      setError("");
    } catch (err) {
      setError(err.message);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>حاسبة القاسم المشترك الأكبر</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>إن حاسبة القاسم المشترك الأكبر تساعدك على إيجاد العامل المشترك الأكبر بين مجموعة من الأعداد بسهولة ودقة.</p>
                <p>ما عليك سوى إدخال الأعداد مفصولة بفواصل، وستقوم الحاسبة بحساب القاسم المشترك الأكبر وتزويدك بالخطوات التفصيلية للعملية الحسابية.
                  <p> هذه الأداة مثالية للطلاب والمعلمين الذين يرغبون في تبسيط الكسور وحل المسائل الرياضية بسرعة.</p>
                  <ul>
                    <li>أدخل الأعداد الصحيحة مفصولة بفواصل في الحقل المخصص.</li>
                    <li>اضغط على زر "احسب" للحصول على القاسم المشترك الأكبر.</li>
                    <li>ستظهر النتيجة مع الخطوات التفصيلية لحساب القاسم المشترك الأكبر.</li>
                  </ul>
                </p>
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>
                    حاسبة القاسم المشترك الأكبر
                  </h2>
                </div>
                <hr />
                <div dir="rtl">
                  <div>
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label ms-2">
                          أدخل الأرقام مفصولة بفواصل
                        </label>
                      </b>
                      <input
                        type="text"
                        placeholder="مثال: 12, 15, 20"
                        value={numbers}
                        onChange={(e) => setNumbers(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      احسب                    </button>
                  </div>
                  <br />
                  <div>
                    { error !== "" ? (
                      <p className="p-3 mb-2 bg-warning text-white">
                        خطأ: {error}
                      </p>
                    ) : (
                      gcf !== null && (
                        <div className="p-3 mb-2 bg-success text-white">
                          <p className="text-white">
                            القاسم المشترك الأكبر: {gcf}
                          </p>
                          <h4 className="text-white">الخطوات:</h4>
                          {steps.map((step, index) => (
                            <p key={index} className="text-white">
                              {step}
                            </p>
                          ))}
                        </div>
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
            <hr /><div className="row">
              <RelatedLinks />
              <hr style={{ width: "100%" }} />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12 col-md-10">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  ما هو القاسم المشترك الأكبر؟
                </h3>
              </div>
              <div className="info-section-body">
                <p>
                  القاسم المشترك الأكبر (GCF) لعددين هو أكبر عدد يمكنه قسمة كلا
                  العددين بدون أي باقي. على سبيل المثال، القاسم المشترك الأكبر
                  لـ 8 و 12 هو 4.
                </p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  كيفية حساب القاسم المشترك الأكبر
                </h3>
              </div>
              <div className="info-section-body">
                <p>
                  يمكن حساب القاسم المشترك الأكبر عن طريق إيجاد العوامل الأولية
                  لكل عدد، ثم أخذ أقل قوة لكل عامل مشترك بينهم للحصول على GCF.
                </p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  أهمية القاسم المشترك الأكبر
                </h3>
              </div>
              <div className="info-section-body">
                <p>
                  يستخدم القاسم المشترك الأكبر في العديد من التطبيقات الرياضية
                  والهندسية، بما في ذلك تبسيط الكسور وحل المسائل العددية.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default GCFCalculator;
